// extracted by mini-css-extract-plugin
export default {"hidden":"downloadSalePDFModal_hidden__mZW+F"};